import {DatePicker} from "@/theme/ui";
import {Form} from "antd";

export const DatePickerFilter = ({name = 'date', ...rest}) => {
    const form = Form.useFormInstance();

    return (
        <>
            <Form.Item
                name={name}
                noStyle
            >
                <DatePicker
                    placeholder="Select date"
                    style={{
                        width: 208,
                    }}
                    format="YYYY-MM-DD"
                    onChange={form.submit}
                    {...rest}
                />
            </Form.Item>
        </>
    );
}